import {Component, OnInit} from '@angular/core';
import {FacadeService} from "../../shared/service-facade/facade.service";
import { MainLayoutService } from '../../shared/services/main-layout.service';
import {ReviewState} from "../../review/models/review-state";

@Component({
  selector: 'app-joint-application',
  templateUrl: './joint-application.component.html',
  styleUrls: ['./joint-application.component.scss']
})

export class JointApplicationComponent implements OnInit {
  reviewState: ReviewState = ReviewState.Initial;
  shouldHideBsaQuestions: boolean = false;

  constructor(
    private facadeService: FacadeService,
    private mainLayout: MainLayoutService) { }

  ngOnInit(): void {
    this.mainLayout.setPageTitle("Submit Your Application");

    this.shouldHideBsaQuestions = this.facadeService.shouldHideBsaQuestions();
  }
}
